export default "__VITE_ASSET__DtZiC3hY__"